/**
 * CEN-CASE — workspace id equality.
 *
 * Workspace ids are UUIDs, and a UUID's hex digits are case-insensitive
 * (RFC 4122; Central's database returns them lower-case). An upper-case id in
 * a URL therefore names the SAME workspace as the lower-case id Central
 * reports. Compare canonically only when BOTH values are UUID-shaped;
 * anything else is an exact comparison — arbitrary ids are never lower-cased.
 * A missing value is never equal to anything (fail closed).
 */
const UUID_SHAPE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function sameWorkspaceId(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b) return false;
  if (UUID_SHAPE.test(a) && UUID_SHAPE.test(b)) return a.toLowerCase() === b.toLowerCase();
  return a === b;
}
